import React, { useContext } from 'react';
import styled from 'styled-components';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import BigButton from '../../components/Photos/BigButton';
import NoPatron from '../../components/layout/Pane/NoPatron';
import Camera from '../../components/Photos/Camera';
import PhotoUpload from '../../components/Photos/PhotoUpload';

import { PatronContext } from '../../contexts/PatronContext';
import { PaneContext } from '../../contexts/PaneContext';

const Photo = () => {
  const { patron } = useContext(PatronContext);
  const { newPatronMode, cameraOn, toggleCamera } = useContext(PaneContext);
  return !patron.PatronID && !newPatronMode ? (
    <NoPatron />
  ) : cameraOn ? (
    <Camera />
  ) : (
    <Container>
      <PhotoUpload />

      <BigButton icon={<CameraAltIcon style={iconStyles}/>} colour='info' onClick={toggleCamera}>
        Use your camera to take a photo.
      </BigButton>
    </Container>
  );
};

const iconStyles ={
  fontSize:'110px',
  marginLeft:'80px',
}

const Container = styled.div`
  padding: 2rem;
  display: grid;
  gap: 2rem;
`;

export default Photo;
